import angular from 'angular';

import Component from './action-summary-modal.component';

const ActionSummaryModal = angular
    .module('control-room.commons.content.component.action-summary-modal', [])
    .component('crActionSummaryModal', Component);

export default ActionSummaryModal;
